import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../components/Layout";
import { Reveal, Label, Diamond } from "../components/Reveal";

const ServicesPage = () => {
  const { lang, t } = useLang();
  useEffect(() => {
    document.title = t.pageTitles.services;
    document.documentElement.lang = lang;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", t.pageDescs.services);
  }, [lang, t]);

  return (
    <>
      <section data-testid="services-hero" className="border-b border-white/10 pt-40 pb-20 md:pb-28">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <Reveal y={24}>
            <Label testId="services-label">{t.services.label}</Label>
            <h1 className="mt-6 max-w-4xl font-serif text-4xl sm:text-6xl font-light leading-[1.08] text-white">
              {t.services.title}
            </h1>
            <p className="mt-8 max-w-2xl text-base md:text-lg font-light leading-relaxed text-white/60">
              {t.services.sub}
            </p>
          </Reveal>
        </div>
      </section>

      <section data-testid="services-grid" className="bg-brand-surface/40">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {t.services.offers.map((o, i) => (
              <Reveal key={o.id} delay={i * 0.08} className="h-full">
                <div
                  data-testid={`service-card-${o.id}`}
                  className={`relative flex h-full flex-col border bg-brand-ink p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 ${
                    o.badge
                      ? "border-brand-gold/60 shadow-[0_0_40px_rgba(201,169,110,0.12)]"
                      : "border-white/10 hover:border-brand-gold/50"
                  }`}
                >
                  {o.badge && (
                    <span className="absolute -top-3 left-8 bg-brand-gold px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-brand-ink">
                      {o.badge}
                    </span>
                  )}
                  <div className="flex items-start justify-between gap-4">
                    <h2 className="font-serif text-2xl font-light text-white">{o.name}</h2>
                    <span className="shrink-0 font-serif text-3xl font-light text-brand-gold">{o.price}</span>
                  </div>
                  <p className="mt-4 text-sm font-light leading-relaxed text-white/60">{o.desc}</p>
                  <ul className="mt-6 flex-1 space-y-3">
                    {o.features.map((f, j) => (
                      <li key={j} className="flex items-start gap-3 text-sm font-light text-white/55">
                        <Diamond className="mt-1 shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                  <Link
                    data-testid={`service-cta-${o.id}`}
                    to={o.to === "kit" ? `/${lang}/kit-digital-premium` : `/${lang}/bilan`}
                    className="mt-8 inline-flex items-center justify-center gap-3 bg-brand-gold px-6 py-3 text-xs font-semibold uppercase tracking-wide text-brand-ink transition-all duration-300 hover:bg-brand-gold-hover"
                  >
                    {o.cta} <ArrowRight size={14} />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesPage;
